import { useCallback } from 'react';
import type { JSX } from 'react';

import { Loader } from '@change-corgi/design-system-legacy/components/progressiveDisclosure';
import { Box } from '@change-corgi/design-system-legacy/layout';

import { LazyComponent } from 'src/app/shared/components/layout/lazy';

import type { AIAsksChoiceWrapper } from './components/AIAsksChoiceWrapper';

async function LoadAIAsksChoiceStep(): Promise<typeof AIAsksChoiceWrapper> {
	return (
		await import(
			/* webpackChunkName: "pages/start-a-petition-steps-ai-asks-choice" */ './components/AIAsksChoiceWrapper'
		)
	).AIAsksChoiceWrapper;
}

export function AIAsksChoiceLoader(): JSX.Element {
	const loadComponent = useCallback(LoadAIAsksChoiceStep, []);

	return (
		<LazyComponent
			loadComponent={loadComponent}
			fallback={
				<Box margin="auto">
					<Loader />
				</Box>
			}
		/>
	);
}

export const preloadAIAsksChoiceStep = LoadAIAsksChoiceStep;
